import React from 'react';
import { PDFViewer, Document } from '@react-pdf/renderer';

export default ({ show, doc }) => {

  return (
    <div className={'invoice-container ' + (show ? '' : 'close')}>
      <PDFViewer>
        {show ? doc : <Document/>}
      </PDFViewer>
    </div>
  )
}
